import { ExcelExportSheetConfig } from "../types";

/** Sales & Catering Excel export sheet definitions — add excelSheet entries here. */
export const sncExcelExportSheets: ExcelExportSheetConfig[] = [];
